import type { CSSProperties } from 'react';

const ALTO_MAX_DROPDOWN = 240;
const ANCHO_MIN_DROPDOWN = 360;
const SEPARACION = 2;
const MARGEN_PANTALLA = 8;

/**
 * Posición (fija) de la lista desplegable de un campo: debajo si entra, arriba si abajo no entra y arriba hay más
 * lugar; el alto se achica al espacio que queda y el ancho/izquierda no se salen de la pantalla.
 */
export function posicionDropdown(
  campo: { top: number; bottom: number; left: number; width: number },
  pantalla: { ancho: number; alto: number },
): CSSProperties {
  const width = Math.max(0, Math.min(Math.max(campo.width, ANCHO_MIN_DROPDOWN), pantalla.ancho - 2 * MARGEN_PANTALLA));
  const left = Math.max(MARGEN_PANTALLA, Math.min(campo.left, pantalla.ancho - width - MARGEN_PANTALLA));
  const base: CSSProperties = { position: 'fixed', left, width, zIndex: 9999 };
  const abajo = pantalla.alto - campo.bottom - SEPARACION - MARGEN_PANTALLA;
  const arriba = campo.top - SEPARACION - MARGEN_PANTALLA;
  if (abajo >= ALTO_MAX_DROPDOWN || abajo >= arriba) {
    return { ...base, top: campo.bottom + SEPARACION, maxHeight: Math.max(0, Math.min(ALTO_MAX_DROPDOWN, abajo)) };
  }
  return { ...base, bottom: pantalla.alto - campo.top + SEPARACION, maxHeight: Math.min(ALTO_MAX_DROPDOWN, arriba) };
}
